import type { LocationState } from './types'

const state = (): LocationState => ({
  lat: null,
  lng: null,
  allowed: null,
  loading: false
})

export default state
